export default __webpack_public_path__ + "static/media/styledCross.35d99c8d.svg";